import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AgentDto, TicketBundleDto, TicketButtonCommunicationDto, TicketButtonDto, TicketDto, TicketHistoryDto, TicketUploadPayload, CommunicationPlaceholders, MemberSearchResultListDto, ResultListDto, WorkflowDto, WorkflowStepDto, WorkflowStepStatusDto, TicketModeEnum } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpTicketService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/ticket', authService);
	}
	public search(phrase: string): Observable<MemberSearchResultListDto> {
		return super.doGet(true, `/member_search?phrase=${encodeURIComponent(phrase)}`);
	}
	// public searchTickets(mode: TicketModeEnum, phrase: string, pageIndex: number, pageSize: number): Observable<ResultListDto<TicketDto>> {
	// 	return super.doGet(true, `/${mode}/ticket_search?phrase=${encodeURIComponent(phrase)}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
	// }
	public queryTickets(workflow: WorkflowDto, agentId: number | null, step?: WorkflowStepDto, pageIndex?: number, pageSize?: number): Observable<ResultListDto<TicketDto>> {
		if (agentId == null) {
			return super.doGet(true, `/ticket_query?workflow=${workflow.id}&step=${step?.id ?? ''}&pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
		} else {
			return super.doGet(true, `/ticket_query?agentId=${agentId}&workflow=${workflow.id}&step=${step?.id ?? ''}&pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
		}
	}
	public get(id: number): Observable<TicketDto> {
		return super.doGet(true, `/${id}`);
	}
	public newTicketForMainMember(workflowId: number, memberId: number): Observable<TicketDto> {
		return super.doGet(true, `/workflow:${workflowId}/member:${memberId}/new`);
	}
	public newTicketForDependant(workflowId: number, dependantId: number): Observable<TicketDto> {
		return super.doGet(true, `/workflow:${workflowId}/dependant:${dependantId}/new`);
	}
	public getTicketHistory(id: number): Observable<TicketHistoryDto> {
		return super.doGet(true, `/${id}/history`);
	}
	public getWorkflows(mode: TicketModeEnum): Observable<WorkflowDto[]> {
		return super.doGet(true, `/${mode}/workflows`);
	}

	public findDuplicateTickets(button: TicketButtonDto, ticket: TicketDto, payload: TicketUploadPayload, categories: string): Observable<TicketDto[]> {
		if (!categories) {
			categories = '';
		}
		if (ticket.dependant) {
			return super.doPost(true, `/workflow:${ticket.workflowId}/dependant:${ticket.dependant.id}/button:${button.id}/find_duplicates?category=${categories}`, payload);
		}
		return super.doPost(true, `/workflow:${ticket.workflowId}/member:${ticket.member.id}/button:${button.id}/find_duplicates?category=${categories}`, payload);
	}
	public submit(button: TicketButtonDto, ticket: TicketDto, payload: TicketUploadPayload, categories: string): Observable<TicketDto> {
		if (ticket.id) {
			return super.doPost(true, `/ticket:${ticket.id}/button:${button.id}/process`, payload);
		}
		if (!categories) {
			categories = '';
		}
		if (ticket.dependant) {
			return super.doPost(true, `/workflow:${ticket.workflowId}/dependant:${ticket.dependant.id}/button:${button.id}/new?category=${categories}`, payload);
		}
		return super.doPost(true, `/workflow:${ticket.workflowId}/member:${ticket.member.id}/button:${button.id}/new?category=${categories}`, payload);
	}
	public submitForPlaceholderValues(button: TicketButtonDto, ticket: TicketDto, payload: TicketUploadPayload, categories: string): Observable<CommunicationPlaceholders> {
		if (ticket.id) {
			return super.doPost(true, `/ticket:${ticket.id}/button:${button.id}/placeholders`, payload);
		}
		if (!categories) {
			categories = '';
		}
		if (ticket.dependant) {
			return super.doPost(true, `/workflow:${ticket.workflowId}/dependant:${ticket.dependant.id}/button:${button.id}/placeholders?category=${categories}`, payload);
		}
		return super.doPost(true, `/workflow:${ticket.workflowId}/member:${ticket.member.id}/button:${button.id}/placeholders?category=${categories}`, payload);
	}

	public getTicketBundle(mode: TicketModeEnum, agentId: number | null, workflowId?: number, pageIndex?: number, pageSize?: number): Observable<TicketBundleDto> {
		let url = `/${mode}/bundle?pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`;
		if (workflowId) {
			url += `&workflowId=${workflowId}`;
		}
		if (agentId) {
			url += `&agentId=${agentId}`;
		}
		return super.doGet(true, url);
	}

	public assignTicketToAgent(ticket: TicketDto, agent: AgentDto): Observable<TicketDto> {
		return super.doPost(true, `/ticket:${ticket.id}/assign/${agent.id}`, {});
	}
	// public getAllWithStats(mode: TicketModeEnum, agentId?: number | null): Observable<WorkflowDto[]> {
	// 	if (agentId != null) {
	// 		return super.doGet(true, `/${mode}/stats?agentId=${agentId}`);
	// 	}
	// 	return super.doGet(true, `/${mode}/stats`);
	// }
	public buildPreview(communication: TicketButtonCommunicationDto, placeholders: CommunicationPlaceholders): Observable<TicketButtonCommunicationDto> {
		const payload: TicketUploadPayload = {
			fieldProperties: {},
			additionalFiles: placeholders,
			requiredCommunications: {},
			additionalCommunications: [communication],
			button: undefined as any as TicketButtonDto
		}
		return super.doPost(true, `/build_preview`, payload);
	}
}
